export default "__VITE_ASSET__b1ea142e__"